import { Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { ListedResource, toListedResource } from "../utils/resourcesListing";

// The back makes every activated planzone resource that isn't a subordinate yet report to the manager, and
// answers them.
function assignEveryoneToManager(httpClient: HttpClient) {
  return (manager: Identifiable<Resource>): Promise<Identifiable<Resource>[]> =>
    httpClient
      .sendHttpRequest<ListedResource[]>({
        endpoint: `/resources/${manager.uuid}/subordinates/everyone`,
        method: HttpMethods.POST,
      })
      .then((resources) => resources.map(toListedResource));
}

export { assignEveryoneToManager };
